import { Apple } from '@mui/icons-material';
import { Button, Stack } from '@mui/material';
import React from 'react';
import { LinuxLogoIcon, WindowsLogoIcon } from './icons/PlatformIcons';

export function isDesktopReleaseActive(release) {
    return release?.active !== false;
}

export function DesktopReleaseDownloadButtons({ release, size = 'large' }) {
    if (!release || !isDesktopReleaseActive(release)) {
        return null;
    }

    const buttons = [
        {
            key: 'windows',
            href: release.download_windows,
            label: 'Baixar para Windows',
            icon: <WindowsLogoIcon />,
        },
        {
            key: 'mac',
            href: release.download_mac,
            label: 'Baixar para Mac',
            icon: <Apple />,
        },
        {
            key: 'linux',
            href: release.download_linux,
            label: 'Baixar para Linux',
            icon: <LinuxLogoIcon />,
        },
    ].filter((item) => Boolean(String(item.href || '').trim()));

    if (buttons.length === 0) {
        return null;
    }

    return (
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} useFlexGap flexWrap="wrap">
            {buttons.map((item) => (
                <Button
                    key={item.key}
                    component="a"
                    href={item.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    variant="outlined"
                    size={size}
                    startIcon={item.icon}
                    sx={{ flex: { sm: 1 }, py: size === 'large' ? 1.25 : undefined, minWidth: { sm: 180 } }}
                >
                    {item.label}
                </Button>
            ))}
        </Stack>
    );
}

export default DesktopReleaseDownloadButtons;
